module.exports = __webpack_public_path__ + "static/img/12.3a8ba71.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/17/eng/12.png
// module id = YLcC
// module chunks = 0